export default __webpack_public_path__ + "static/medgas_valve_box_w.4be0be1a4afa064ad35097c87942c8c3.png";